export default {
  LOADER_VERSION: '5.1.2',
  EVENTS: {
    ERROR_LOADING_WIDGET: 'errorLoadingWidget',
    REFRESH_WIDGET: 'refreshWidget',
  }
}


// WEBPACK FOOTER //
// ./src/constants.js